;(function (window, $) {
    let product_add = $('.product-add');
    let checkout_btn = $('#checkout');
    let logo = "//www.saracen.co.uk/cdn/shop/t/34/assets/Cyclescheme_logo.png?v=49617745669928759591745852926";
    let logo_white = "//www.saracen.co.uk/cdn/shop/t/34/assets/Cyclescheme_white_logo.png?v=17326797248786146261745852927";
    if ($(product_add).length) {
        $(product_add).on("DOMSubtreeModified ", function () {
            if (!$(product_add).find('.cyclescheme_info').length) {
                let payment_button_more = $('.shopify-payment-button__more-options');
                let product_info_template = '<div class="cyclescheme_info "><img src="' + logo + '" alt="CYCLESCHEME"><p><strong>Paying With Cyclescheme?</strong> <br>Redeem your certificate in the cart</p></div>';
                $(product_info_template).insertBefore($(payment_button_more));
            }
        });
    }
    if ($(checkout_btn).length) {
        let form_template = '' +
            '<div class="cyclescheme_btn"><div class="cyclescheme_loading"></div>' +
            '        <div class="cyclescheme_header">' +
            '            <span>PAY WITH CYCLESCHEME VOUCHER</span>' +
            '            <img src="' + logo_white + '" alt="CYCLESCHEME">' +
            '            <div class="cyclescheme_form_alert cyclescheme_form_alert_first">' +
            '                <p>' +
            '                    <strong>Paying With Cyclescheme.</strong><br>' +
            '                    Your bicycle and accessories will be purchased using your Cyclescheme certificate, however you will need to pay a £50 delivery fee via another means in the checkout.' +
            '                </p>' +
            '                <p class="cyclescheme_form_confirmation">' +
            '                    <span>Please click okay to acknowledge this message:</span>' +
            '                    <button class="btn">OK</button>' +
            '                </p>' +
            '            </div>' +
            '        </div>' +
            '        <div class="cyclescheme_form">' +
            '            <p><strong>*Cyclescheme Certificates are single-use only</strong></p>' +
            '            <p>Please make sure you have added all the items you wish to' +
            '                purchase to the cart before you redeem your certificate.</p>' +
            '            ' +
            '                <input type="text" name="number" placeholder="Certificate Number" maxlength="32">' +
            '                <div class="cyclescheme_form_group">' +
            '                    <input type="text" name="code" placeholder="Code" maxlength="32">' +
            '                    <button class="btn">Redeem voucher</button>' +
            '                </div>' +
            '            ' +
            '            <span class="cyclescheme_error"></span><div class="cyclescheme_form_success">' +
            '                <p style="display: none;">' +
            '                    <strong>Your certificate has been redeemed:</strong><br>' +
            '                    You must complete checkout by clicking the button below:' +
            '                </p>' +
            '                <div class="cyclescheme_form_checkout"></div>' +
            '            </div>' +
            '            <div class="cyclescheme_form_alert cyclescheme_form_alert_last">' +
            '                <p>' +
            '                    <strong>Your Cyclescheme Certificate is single-use only.</strong><br>' +
            '                    Your full Certificate value will be redeemed regardless of' +
            '                    basket value. You must pay the £30 delivery charge in the checkout.' +
            '                </p>' +
            '                <p class="cyclescheme_form_confirmation">' +
            '                    <span>Please click okay to acknowledge this message:</span>' +
            '                    <button class="btn">OK</button>' +
            '                </p>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '';
        $(form_template).insertAfter($(checkout_btn));
        let cyclescheme_btn = $('.cyclescheme_btn');
        let loading = $('.cyclescheme_loading');
        let header = $('.cyclescheme_header');
        let alert = $('.cyclescheme_form_alert_last');
        let alert_first = $('.cyclescheme_form_alert_first');
        let success =  $('.cyclescheme_form_success');
        let form = $('.cyclescheme_form');
        let input_number = $('.cyclescheme_form [name="number"]');
        let input_code = $('.cyclescheme_form [name="code"]');
        let cyclescheme_api_url = 'https://saracen.chorleydigitalhub.com/api/';
        let body = $("body");
        $(body).delegate('.cyclescheme_header', "click", function (e){
            e.preventDefault();
            $(alert_first).show();
        })
        $(body).delegate('.cyclescheme_form_alert_first .cyclescheme_form_confirmation .btn', "click", function (e) {
            e.preventDefault();
            $(alert_first).remove();
            $(checkout_btn).prop("disabled", true);
            $(cyclescheme_btn).addClass('open');
            $(form).show();
        });
        $(body).delegate('.cyclescheme_form > .cyclescheme_form_group > .btn', "click", function (e){
            e.preventDefault();
            if(!input_number.val()){
                input_number.addClass('error');
            } else if(!input_code.val()){
                input_code.addClass('error');
            } else {
                if(!$('.cyclescheme_error .error').length){
                    $(loading).show();
                    $('.cyclescheme_error').html('');
                    $.getJSON('/cart.js', function(cart) {
                        $.ajax(cyclescheme_api_url + 'certificateCheck', {
                            type: "POST",
                            crossDomain: true,
                            data: {
                                "cart": cart,
                                "certificate_number": input_number.val(),
                                "certificate_code": input_code.val(),
                            },
                            statusCode: {
                                200: function (response) {
                                    $(this).prop("disabled", true);
                                    $(alert).show();
                                },
                                422: function (r) {
                                    let response = r['responseJSON'];
                                    if(response.hasOwnProperty('error')){
                                        $('.cyclescheme_error').html('<span class="error">' + response['error']['message'] + '</span>');
                                    }
                                }
                            },
                        }).always(function() {
                            $(loading).hide();
                        });
                    } );
                }
            }
        });

        $(document).on("click", function(event) {
            let $target = $(event.target);
            if(!$target.closest('.cyclescheme_form_alert').length &&
                $(alert).is(":visible") &&
                !$target.closest('.cyclescheme_form > .cyclescheme_form_group > .btn').length) {
                $('.cyclescheme_form > .cyclescheme_form_group > .btn').prop("disabled", false);
                $(alert).hide();
            }
        });

        $(body).delegate('.cyclescheme_form [name="number"], .cyclescheme_form [name="code"]', "focus", function (e){
            $(this).removeClass('error');
            $('.cyclescheme_error').html('');
        });

        $(body).delegate('.cyclescheme_form [name="number"],.cyclescheme_form [name="code"]', "input", function (e){
            e.preventDefault();
            if($('.cyclescheme_form [name="number"]').val() && $('.cyclescheme_form [name="code"]').val()){
                $('.cyclescheme_form > .cyclescheme_form_group > .btn').prop("disabled", false);
            } else {
                $('.cyclescheme_form > .cyclescheme_form_group > .btn').prop("disabled", true);
            }
        });

        $(body).delegate('.cyclescheme_form_alert_last .cyclescheme_form_confirmation .btn', "click", function (e){
            e.preventDefault();
            $(loading).show();
            $('.cyclescheme_form > .cyclescheme_form_group > .btn').prop("disabled", false);
            $(alert).hide();
            $('.cyclescheme_error').html('');
            $.getJSON('/cart.js', function(cart) {
                $.ajax(cyclescheme_api_url + 'certificateActive', {
                    type: "POST",
                    crossDomain: true,
                    data: {
                        "cart": cart,
                        "certificate_number": input_number.val(),
                        "certificate_code": input_code.val(),
                    },
                    statusCode: {
                        200: function (response) {
                            if(response.hasOwnProperty('success')){
                                if(response['success'].hasOwnProperty('discount_url')){
                                    let discount_url = response['success']['discount_url'];
                                    window.location.replace(discount_url);
                                    $(alert).hide();
                                    $(success).show();
                                }
                            }
                        },
                        422: function (r) {
                            let response = r['responseJSON'];
                            if(response.hasOwnProperty('error')){
                                $('.cyclescheme_error').html('<span class="error">' + response['error']['message'] + '</span>');
                            }
                        }
                    },
                }).always(function() {
                    $(loading).hide();
                });
            } );
        })


    }
})(window, jQuery)
